<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('inventory.inventory-information.title')}}">
		<div class="container-fluid">
			<iframe [src]="safeUrl" style="border: 0" width="100%" height="600" scrolling="auto"></iframe>
		</div>
	</jhi-collapsible>
</div>
